import React from 'react'

import useForm from 'react-hook-form'
import { RHFInput } from 'react-hook-form-input'

import {
  Button,
  Card,
  LinearProgress,
  Link,
  TextField,
  Typography,
  makeStyles,
} from '@material-ui/core'

import { CheckCircleOutlineOutlined } from '@material-ui/icons'

import logo from 'images/yapay.svg'
import * as service from 'service'
import styles from './styles'
import schemas from './schemas'
import useSnackbar from 'hooks/useSnackbar'

const useStyles = makeStyles(styles)

export const PasswordReset = ({ history }) => {
  const classes = useStyles()
  const snackbar = useSnackbar()

  const [loading, setLoading] = React.useState(false)
  const [success, setSuccess] = React.useState(false)

  const { register, setValue, handleSubmit, errors } = useForm({
    validationSchema: schemas.passwordReset,
    defaultValues: {
      email: '',
    },
  })

  const onSubmit = async data => {
    setLoading(true)

    try {
      await service.recurrence.auth.resetPassword(data.email)
      setLoading(false)
      setSuccess(true)
    } catch (error) {
      if (error && error.response && error.response.status === 404) {
        snackbar.open({
          message: 'Usuário não encontrado(a)',
          variant: 'error',
        })

        return
      }

      snackbar.open({
        message: 'Ocorreu algum erro! Tente novamente!',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  const handleClick = e => {
    e.preventDefault()
    history.goBack()
  }

  return (
    <>
      <img alt="Logo" src={logo} width="100%" className={classes.logo} />

      <form onSubmit={handleSubmit(onSubmit)} className={classes.form}>
        <Card className={classes.card}>
          {loading && <LinearProgress className={classes.progress} />}

          {success ? (
            <div className={classes.successContainer}>
              <CheckCircleOutlineOutlined
                color="action"
                className={classes.successIcon}
              />
              <Typography variant="h4" align="center" className={classes.title}>
                Sucesso!
              </Typography>
              <Typography
                variant="subtitle2"
                align="center"
                className={classes.subTitle}
              >
                Você receberá um email com as instruções para recuperação de
                senha
              </Typography>
            </div>
          ) : (
            <div>
              <Typography variant="h4" align="center" className={classes.title}>
                Recuperar senha
              </Typography>

              <Typography
                variant="subtitle2"
                align="center"
                className={classes.subTitle}
              >
                Informe seu e-mail de cadastro para receber um link e cadastrar
                uma nova senha
              </Typography>

              <RHFInput
                as={
                  <TextField
                    label="Email"
                    type="email"
                    variant="outlined"
                    disabled={loading}
                    error={!!errors.email}
                    helperText={errors && errors.email && errors.email.message}
                    fullWidth
                    className={classes.field}
                  />
                }
                register={register}
                setValue={setValue}
                name="email"
                mode="onChange"
              />

              <Button
                variant="contained"
                color="primary"
                type="submit"
                disabled={loading}
                fullWidth
                size="large"
                className={classes.button}
              >
                {loading ? 'Carregando...' : 'Continuar'}
              </Button>

              <Link href="/" onClick={handleClick}>
                <Typography align="center" className={classes.linkBack}>
                  Voltar para o login
                </Typography>
              </Link>
            </div>
          )}
        </Card>
      </form>
    </>
  )
}

export default PasswordReset
